import React from 'react';
import {Icon, Popup} from 'semantic-ui-react';

import {Props} from './types';

import './index.scss';

const Normal: React.FC<Props> = props => {
  return (
    <div className="a__popup">
      <Popup
        content={props.content}
        trigger={
          props.attention ? (
            <Icon name="attention" style={{color: '#ff847c'}} />
          ) : (
            <Icon name="question circle outline" />
          )
        }
        className="b__content"
        position={props.position || 'top left'}
        on={props.on}
        basic={props.basic}
      />
    </div>
  );
};

export default Normal;
